import { createColumnHelper } from "@tanstack/react-table";
import { formatSize, toNumber } from "#/lib/formatters";

export type PortfolioBalanceRow = {
	coin: string;
	total: string;
	hold: string;
	entryNtl: string;
};

const col = createColumnHelper<PortfolioBalanceRow>();

export function createPortfolioBalanceColumns(t: (key: string) => string) {
	return [
		col.accessor("coin", {
			header: () => t("portfolio.coin"),
			cell: (info) => (
				<span className="text-label2-medium">{info.getValue()}</span>
			),
		}),
		col.accessor("total", {
			header: () => t("portfolio.total"),
			cell: (info) => (
				<span className="text-right text-label2-tabular-medium">
					{formatSize(toNumber(info.getValue()))}
				</span>
			),
		}),
		col.display({
			id: "available",
			header: () => t("portfolio.available"),
			cell: ({ row }) => {
				const total = toNumber(row.original.total);
				const hold = toNumber(row.original.hold);
				return (
					<span className="text-right text-label2-tabular-medium">
						{formatSize(Math.max(0, total - hold))}
					</span>
				);
			},
		}),
	];
}
